module.exports = __webpack_public_path__ + "img/960.3ee28150.svg";